import React from 'react';
import styles from './EULA.module.css';

const eula = () => (
  <div className={styles.container}>
    <h1>Terms of Use (End User License Agreement)</h1>
    <p>
      <strong>Effective Date:</strong> July 19, 2025 &nbsp;&nbsp;|&nbsp;&nbsp;
      <strong>Last Updated:</strong> July 19, 2025
    </p>

    <p>
      This End User License Agreement (“Agreement”, “Terms of Use”, or “EULA”) is a legal agreement
      between you (“you”, “your”, or “User”) and Loggable LLC (“Loggable”, “we”, “us”, or “our”) governing
      your use of the Loggable mobile application, web application, and any associated services
      (collectively, the “Software”).
    </p>

    <p>
      By downloading, installing, accessing, or using the Software, you confirm that you understand
      and agree to be bound by this EULA. If you do not agree to these terms, you may not use the Software.
    </p>

    <h2>1. License Grant</h2>
    <p>
      Loggable grants you a limited, revocable, non-exclusive, non-transferable license to use the
      Software for personal or internal business purposes in accordance with this Agreement.
    </p>
    <p>
      This license does not permit you to:
    </p>
    <ul>
      <li>Distribute, sell, sublicense, or lease the Software</li>
      <li>Modify, reverse engineer, decompile, or disassemble the Software</li>
      <li>Circumvent security, access controls, or usage limits</li>
      <li>Use the Software in violation of any applicable laws</li>
    </ul>

    <h2>2. Ownership</h2>
    <p>
      The Software is licensed, not sold. Loggable LLC retains all rights, title, and interest in the
      Software, including all intellectual property rights. No rights are granted to you other than
      those expressly stated in this EULA.
    </p>

    <h2>3. User Responsibilities</h2>
    <p>
      You agree to use the Software responsibly and only for lawful purposes. You are responsible for:
    </p>
    <ul>
      <li>Maintaining the confidentiality of your login credentials</li>
      <li>Ensuring all data you upload is lawful and does not infringe on third-party rights</li>
      <li>Compliance with all applicable aviation, data, and privacy regulations when exporting or managing logbook data</li>
    </ul>

    <h2>4. Subscription and Payments</h2>
    <p>
      Some features of Loggable require an active subscription, processed by Stripe or Apple/Google 
      in-app payments. Subscriptions automatically renew unless canceled in accordance with the
      respective app store policies.
    </p>
    <p>
      Prices, terms, and billing cycles are displayed in the app at the time of purchase.
    </p>

    <h2>5. Data and Content</h2>
    <p>
      You retain ownership of the logbook entries and content you create using the Software.
      By using the Software, you grant Loggable a limited license to store, process, and transmit
      your data solely to operate the Service.
    </p>

    <h2>6. Third-Party Services</h2>
    <p>
      The Software uses third-party technology including AWS, Stripe, and OpenAI. Your use of these
      services may also be governed by their own terms, conditions, and privacy policies.
    </p>

    <h2>7. Termination</h2>
    <p>
      Loggable may suspend or terminate your access to the Software at any time for violating this EULA.
      You may terminate this Agreement by deleting your account and uninstalling the Software.
    </p>

    <h2>8. Disclaimer of Warranty</h2>
    <p>
      The Software is provided on an “as is” and “as available” basis. Loggable makes no warranties,
      express or implied, including but not limited to warranties of merchantability, fitness for a 
      particular purpose, accuracy of digitization, or uninterrupted service.
    </p>

    <h2>9. Limitation of Liability</h2>
    <p>
      To the fullest extent permitted by law, Loggable shall not be liable for any indirect, incidental,
      special, consequential, or exemplary damages arising out of your use of the Software.
    </p>

    <h2>10. Governing Law</h2>
    <p>
      This Agreement is governed by the laws of Pennsylvania, United States of America, without regard
      to conflict-of-law principles.
    </p>

    <h2>11. Changes to This Agreement</h2>
    <p>
      We may update this EULA from time to time. The “Last Updated” date will reflect any changes.
      Continued use of the Software after an update constitutes acceptance of the revised terms.
    </p>

    <h2>12. Contact Information</h2>
    <p>
      For questions regarding this EULA, contact us at{' '}
      <a href="mailto:support@loggable.net">support@loggable.net</a>.
    </p>
  </div>
);

export default eula;
